"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var player_react_portal_1 = require("player-react-portal");
var portal_position_1 = require("player-react-portal/build/portal-position");
var react_hotkeys_1 = require("react-hotkeys");
var Utils = require("player-core/utils");
require("./ButtonDropdown.css");
var ButtonDropdownStyles = {
    BORDERED: 'bordered',
    BORDERLESS: 'borderless',
    MEATBALL: 'meatball'
};
exports.EVENT_KEY = {
    DOWN: "ArrowDown",
    END: "End",
    ENTER: "Enter",
    ESCAPE: "Escape",
    HOME: "Home",
    SPACE: " ",
    TAB: "Tab",
    UP: "ArrowUp",
};
exports.PORTAL_KEYCODE = {
    DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    UP: 38,
};
exports._findIndex = function (arr, booleanFunc) {
    if (typeof arr.findIndex === "function") {
        return arr.findIndex(booleanFunc);
    }
    else {
        var foundInd = -1;
        for (var i = 0; i < arr.length; i += 1) {
            if (booleanFunc(arr[i])) {
                foundInd = i;
                break;
            }
        }
        return foundInd;
    }
    ;
};
var ButtonDropdown = (function (_super) {
    __extends(ButtonDropdown, _super);
    function ButtonDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this._repositionDropdownList = _this._repositionDropdownList.bind(_this);
        _this._onDropdownClose = _this._onDropdownClose.bind(_this);
        _this.state = {
            listTop: 0,
            listLeft: 0,
            listPositioned: false
        };
        _this._onActionClick = _this._onActionClick.bind(_this);
        _this._dropdownID = _this.props.id || Utils.createUUID();
        _this._listID = Utils.createUUID();
        return _this;
    }
    ButtonDropdown.prototype._onActionClick = function (value) {
        this.props.onActionClick && this.props.onActionClick(value);
    };
    ButtonDropdown.prototype._repositionDropdownList = function () {
        var _this = this;
        requestAnimationFrame(function () {
            _this.props.onDropdownOpen && _this.props.onDropdownOpen(_this.props.id);
            var coordinates = portal_position_1.positionDropdown(_this._dropdownElem._listElem, _this._dropdownTrigger, document.body);
            _this.setState({
                listTop: coordinates.top,
                listLeft: coordinates.left,
                listPositioned: true,
            });
        });
        return {};
    };
    ButtonDropdown.prototype._onDropdownClose = function () {
        this.setState({
            listTop: 0,
            listLeft: 0,
            listPositioned: false,
        });
        this.props.onDropdownClose && this.props.onDropdownClose(this.props.id);
        return {};
    };
    ButtonDropdown.prototype.render = function () {
        var _this = this;
        var propsTrigger = {
            'id': this._dropdownID,
            'type': 'button',
            'aria-haspopup': "true",
            'aria-expanded': this.state.listPositioned,
            'title': this.props.label,
            'ref': function (c) { _this._dropdownTrigger = c; }
        };
        var buttonText = React.createElement("span", null);
        if (this.props.style === ButtonDropdownStyles.MEATBALL) {
            propsTrigger['aria-label'] = this.props.label;
            propsTrigger['className'] = "p-icon-three-dots";
        }
        if (this.props.style === ButtonDropdownStyles.BORDERLESS) {
            propsTrigger['className'] = "p-dropdown-borderless";
            buttonText = React.createElement("span", null, this.props.label);
        }
        if (this.props.style === ButtonDropdownStyles.BORDERED) {
            propsTrigger['className'] = "p-dropdown-bordered p-bc-f-blue50 p-bc-grey60 p-bg-hv-white";
            buttonText = React.createElement("span", null, this.props.label);
        }
        var _dropdownTrigger = React.createElement("button", __assign({}, propsTrigger),
            buttonText,
            this.props.style !== ButtonDropdownStyles.MEATBALL && React.createElement("span", { className: "p-icon-down-triangle" }));
        return (React.createElement("div", { className: "p-button-dropdown", "data-tag": this.props.tag },
            React.createElement(player_react_portal_1.Portal, { openOnDownArrow: true, openOnUpArrow: true, onOpen: this._repositionDropdownList, onClose: this._onDropdownClose, closeOnEsc: true, closeOnOutsideClick: true, openByClickOn: _dropdownTrigger },
                React.createElement(ButtonDropdownList, { ref: function (node) { _this._dropdownElem = node; }, top: this.state.listTop, left: this.state.listLeft, isPositioned: this.state.listPositioned, dropdownTrigger: this._dropdownTrigger, items: this.props.items, onClick: this._onActionClick, ariaLabelledby: this._dropdownID, listId: this._listID, maxHeight: this.props.dropdownMaxHeight, isFullWidthOnMobile: this.props.isFullWidthOnMobile }))));
    };
    return ButtonDropdown;
}(React.Component));
ButtonDropdown.defaultProps = {
    items: [],
    tag: null,
    label: null,
    id: '',
    style: 'meatball',
    dropdownMaxHeight: null,
    isFullWidthOnMobile: false
};
exports.ButtonDropdown = ButtonDropdown;
var ButtonDropdownList = (function (_super) {
    __extends(ButtonDropdownList, _super);
    function ButtonDropdownList(props) {
        var _this = _super.call(this, props) || this;
        _this.hotKeysMap = {
            '_moveFocusList': ['down', 'end', 'home', 'up'],
            '_moveFocusTrigger': ['shift+tab', 'tab'],
            '_closeAndRefocus': 'esc',
            '_onEnter': 'enter',
        };
        _this._isEnabledListItem = function (item) { return !item.disabled; };
        _this._onClick = _this._onClick.bind(_this);
        _this._moveFocusList = _this._moveFocusList.bind(_this);
        _this._moveFocusTrigger = _this._moveFocusTrigger.bind(_this);
        _this._closeAndRefocus = _this._closeAndRefocus.bind(_this);
        _this._onEnter = _this._onEnter.bind(_this);
        _this.state = { focusedIndex: 0 };
        return _this;
    }
    ButtonDropdownList.prototype._moveFocusList = function (e) {
        if (!this._listElemNodes || !this._listElemNodes.length)
            return;
        e.preventDefault();
        var listLength = this._listElemNodes.length;
        var disabledItems = this._listElemNodes.filter(function (item) { return item.disabled; });
        var focusableItemsLength = listLength - disabledItems.length;
        if (focusableItemsLength <= 1)
            return;
        var focusIndex = -1;
        var listElemNodes = this._listElemNodes.slice();
        switch (e.key) {
            case exports.EVENT_KEY.DOWN: {
                var tempInd = (this.state.focusedIndex + 1) % listLength;
                while (focusIndex === -1) {
                    if (!listElemNodes[tempInd].disabled)
                        focusIndex = tempInd;
                    else
                        tempInd = (tempInd + 1) % listLength;
                }
                break;
            }
            case exports.EVENT_KEY.END: {
                var reversedInd = exports._findIndex(listElemNodes.reverse(), this._isEnabledListItem);
                focusIndex = (listLength - 1) - reversedInd;
                break;
            }
            case exports.EVENT_KEY.HOME: {
                focusIndex = exports._findIndex(listElemNodes, this._isEnabledListItem);
                break;
            }
            case exports.EVENT_KEY.UP: {
                var tempInd = (this.state.focusedIndex + listLength - 1) % listLength;
                while (focusIndex === -1) {
                    if (!listElemNodes[tempInd].disabled)
                        focusIndex = tempInd;
                    else
                        tempInd = (tempInd + listLength - 1) % listLength;
                }
                break;
            }
            default:
                break;
        }
        if (focusIndex > -1) {
            this.setState({ focusedIndex: focusIndex });
            this._listElemNodes[focusIndex].focus();
        }
    };
    ButtonDropdownList.prototype._moveFocusTrigger = function (e) {
        if (!this.props.dropdownTrigger)
            return;
        e.preventDefault();
        this.props.closePortal();
        var selector = 'a:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input[type=text]:not([disabled]):not([tabindex="-1"]), [tabindex]:not([disabled]):not([tabindex="-1"])';
        var nodeList = document.querySelectorAll(selector);
        var focusableElements = Array.prototype.slice.call(nodeList).filter(function (el) {
            var styles = window.getComputedStyle(el);
            if (styles.display !== "none" &&
                styles.visibility !== "hidden" &&
                styles.opacity !== "0")
                return true;
            return false;
        });
        if (focusableElements.length <= 1)
            return;
        var triggerInd = focusableElements.indexOf(this.props.dropdownTrigger);
        var focusIndex = -1;
        if (e.shiftKey && triggerInd !== 0)
            focusIndex = triggerInd - 1;
        else if (!e.shiftKey && triggerInd !== focusableElements.length - 1)
            focusIndex = triggerInd + 1;
        if (focusIndex > -1)
            focusableElements[focusIndex].focus();
    };
    ButtonDropdownList.prototype._closeAndRefocus = function (e) {
        e && e.preventDefault();
        this.props.closePortal && this.props.closePortal();
        this.props.dropdownTrigger && this.props.dropdownTrigger.focus();
    };
    ButtonDropdownList.prototype._closePortal = function (item) {
        if (typeof item.closeOnClick === "undefined" || item.closeOnClick) {
            this._closeAndRefocus();
        }
    };
    ButtonDropdownList.prototype._onClick = function (value, index, childIndex) {
        this.props.onClick && this.props.onClick(value);
        if (Array.isArray(this.props.items[index])) {
            this._closePortal(this.props.items[index][childIndex]);
        }
        else {
            var item = this.props.items[index];
            this._closePortal(item);
        }
    };
    ButtonDropdownList.prototype._onEnter = function (e) {
        e.preventDefault();
        if (e !== null && e.target instanceof HTMLElement) {
            var element = e.target;
            var itemValue = element.dataset.item;
            var index = element.dataset.index;
            var childIndex = element.dataset.children;
            this._onClick(itemValue, index, childIndex);
        }
    };
    ;
    ButtonDropdownList.prototype._renderListItems = function (item, index, childIndex) {
        if (childIndex === void 0) { childIndex = null; }
        return (React.createElement("li", { role: "menuitem", "data-disabled": "false", "data-id": index, key: childIndex ? index + "-" + childIndex : index, "aria-label": item.ariaLabel ? item.ariaLabel : item.label, tabIndex: -1, "aria-disabled": item.isDisabled, title: item.title, onClick: this._onClick.bind(this, item.value, index, childIndex), "data-item": item.value, "data-index": index, "data-children": childIndex ? childIndex : null }, item.label));
    };
    ButtonDropdownList.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.items.length !== this.props.items.length) {
            this._listElemNodes = Array.prototype.slice.call(this._listElem.querySelectorAll('li[aria-disabled="false"],li:not([aria-disabled])'));
            if (this._listElemNodes[0]) {
                this._listElemNodes[0].focus();
            }
            this.setState({ focusedIndex: 0 });
        }
    };
    ButtonDropdownList.prototype.componentDidMount = function () {
        this._listElemNodes = Array.prototype.slice.call(this._listElem.querySelectorAll('li[aria-disabled="false"],li:not([aria-disabled])'));
        var listLength = this._listElemNodes.length;
        if (listLength) {
            var disabledItems = this._listElemNodes.filter(function (item) { return item.disabled; });
            if (disabledItems.length === listLength)
                return;
            var focusIndex = 0;
            var listElemNodes = this._listElemNodes.slice();
            if (this.props.openedByKeyPress === exports.PORTAL_KEYCODE.UP) {
                var reversedInd = exports._findIndex(listElemNodes.reverse(), this._isEnabledListItem);
                focusIndex = (listLength - 1) - reversedInd;
            }
            else {
                focusIndex = exports._findIndex(listElemNodes, this._isEnabledListItem);
            }
            this._listElemNodes[focusIndex].focus();
            this.setState({ focusedIndex: focusIndex });
        }
    };
    ButtonDropdownList.prototype.render = function () {
        var _this = this;
        var inlineStyles = {
            left: this.props.left + 'px',
            top: this.props.top + 'px'
        };
        var classes = ['p-button-dropdown-list'];
        if (this.props.maxHeight) {
            inlineStyles['maxHeight'] = this.props.maxHeight;
        }
        else {
            classes.push('no-max-height');
        }
        var handlers = {
            '_moveFocusList': this._moveFocusList,
            '_moveFocusTrigger': this._moveFocusTrigger,
            '_closeAndRefocus': this._closeAndRefocus,
            '_onEnter': this._onEnter
        };
        this.props.isFullWidthOnMobile && classes.push('mobile-full-width');
        !this.props.isPositioned && classes.push('dislocated');
        var listItems = this.props.items.map(function (item, index) {
            if (Array.isArray(item)) {
                return (React.createElement("ul", { className: "p-list-item-group", key: index + "+" + item }, item.map(function (i, idx) { return _this._renderListItems(i, index, idx); })));
            }
            return _this._renderListItems(item, index);
        });
        return (React.createElement(react_hotkeys_1.HotKeys, { keyMap: this.hotKeysMap, handlers: handlers },
            React.createElement("div", { ref: function (c) { _this._listElem = c; }, style: inlineStyles, className: classes.join(' ') },
                React.createElement("ul", { id: this.props.listId, role: "menu", "aria-labelledby": this.props.ariaLabelledby }, listItems))));
    };
    return ButtonDropdownList;
}(React.Component));
ButtonDropdownList.defaultProps = {
    top: 0,
    left: 0,
    isPositioned: false,
    items: [],
    maxHeight: null,
    isFullWidthOnMobile: false
};
exports.ButtonDropdownList = ButtonDropdownList;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['ButtonDropdown'] = ButtonDropdown;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["ButtonDropdown"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/ButtonDropdown/index.js
// module id = 291
// module chunks = 0